<orbit-dialog-header [title]="data.title" />

<div class="dialog-content">
  <!-- Confirmation dialog content -->
  @if (isConfirmation) {
    <div class="confirmation-message">
      <p>{{ data.message }}</p>
    </div>
  }

  <!-- User form content -->
  @if (!isConfirmation) {
    <form [formGroup]="userForm" class="user-form">
      <!-- Error message -->
      @if (errorMessage) {
        <div class="form-error-message">
          <p>{{ errorMessage }}</p>
        </div>
      }

      <div class="form-group">
        <label for="email">{{ 'SETTINGS.USERS.EMAIL' | translate }} *</label>
        <input
          type="email"
          id="email"
          formControlName="email"
          [placeholder]="'SETTINGS.USERS.EMAIL_PLACEHOLDER' | translate" />
        @if (userForm.get('email')?.invalid && userForm.get('email')?.touched) {
          <div class="error-message">
            {{ 'SETTINGS.USERS.EMAIL_REQUIRED' | translate }}
          </div>
        }
      </div>

      <!-- Only show password field when creating a new user -->
      @if (!isEditMode) {
        <div class="form-group">
          <label for="password">{{ 'SETTINGS.USERS.PASSWORD' | translate }} *</label>
          <input
            type="password"
            id="password"
            formControlName="password"
            [placeholder]="'SETTINGS.USERS.PASSWORD_PLACEHOLDER' | translate" />
          @if (userForm.get('password')?.invalid && userForm.get('password')?.touched) {
            <div class="error-message">
              {{ 'SETTINGS.USERS.PASSWORD_REQUIRED' | translate }}
            </div>
          }
        </div>
      }

      <div class="form-row">
        <div class="form-group">
          <label for="firstname">{{ 'SETTINGS.USERS.FIRSTNAME' | translate }} *</label>
          <input
            type="text"
            id="firstname"
            formControlName="firstname"
            [placeholder]="'SETTINGS.USERS.FIRSTNAME_PLACEHOLDER' | translate" />
          @if (userForm.get('firstname')?.invalid && userForm.get('firstname')?.touched) {
            <div class="error-message">
              {{ 'SETTINGS.USERS.FIRSTNAME_REQUIRED' | translate }}
            </div>
          }
        </div>

        <div class="form-group">
          <label for="lastname">{{ 'SETTINGS.USERS.LASTNAME' | translate }} *</label>
          <input
            type="text"
            id="lastname"
            formControlName="lastname"
            [placeholder]="'SETTINGS.USERS.LASTNAME_PLACEHOLDER' | translate" />
          @if (userForm.get('lastname')?.invalid && userForm.get('lastname')?.touched) {
            <div class="error-message">
              {{ 'SETTINGS.USERS.LASTNAME_REQUIRED' | translate }}
            </div>
          }
        </div>
      </div>

      <div class="form-group">
        <label for="role">{{ 'SETTINGS.USERS.ROLE' | translate }}</label>
        <select id="role" formControlName="role">
          @for (role of roles; track role) {
            <option [value]="role">
              {{ 'SETTINGS.USERS.ROLES.' + role | translate }}
            </option>
          }
        </select>
      </div>
    </form>
  }
</div>

<orbit-dialog-footer>
  <div class="right-addon" right-addon>
    <orbit-button
      [flat]="true"
      [disabled]="loading"
      [label]="data.cancelLabel"
      (onClick)="closeDialog(false)" />
    <orbit-button
      [disabled]="!isConfirmation && (userForm.invalid || loading)"
      [label]="data.confirmLabel"
      (onClick)="closeDialog(true)" />
  </div>
</orbit-dialog-footer>
